interface ProgressBarProps {
  progress: number;
  label: string;
  accentColor: string;
}

export function ProgressBar({ progress, label, accentColor }: ProgressBarProps) {
  const pct = Math.round(progress * 100);
  return (
    <div style={{ background: "#fff", padding: "10px 20px", borderBottom: "1px solid #e8e8e8" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
        <span style={{ fontSize: 12, fontWeight: 600, color: "#888" }}>{label}</span>
        <span style={{ fontSize: 12, fontWeight: 700, color: accentColor }}>{pct}%</span>
      </div>
      <div style={{ height: 6, background: "#e8e8e8", borderRadius: 3, overflow: "hidden" }}>
        <div style={{
          height: "100%",
          width: `${Math.min(pct, 100)}%`,
          background: `linear-gradient(90deg, ${accentColor}, #1abac4)`,
          borderRadius: 3,
          transition: "width 0.3s ease",
        }} />
      </div>
    </div>
  );
}
